import script from "./Ver.vue?vue&type=script&setup=true&lang=js"
export * from "./Ver.vue?vue&type=script&setup=true&lang=js"

import "./Ver.vue?vue&type=style&index=0&id=d92e482e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d92e482e"]])

export default __exports__